import Boss from "./Boss";

export default class BossHobgoblin extends Boss {
    constructor() {
        super("adversary_hobgoblin", Boss.TYPE_HOBGOBLIN);

        this.scale.set(0.34);

        this.setIdleAnims(["idle"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
        this.setEnterAnims(["enter"]);

        this._attackSoundName = "sfx_hobgoblin_attack_00";
        this._enterSoundName = "sfx_enter_hobgoblin";
    }

    init() {
        super.init(P3.utils.selectRandom(["hobgoblin1", "hobgoblin2"]));
    }
}